import { fetchPrivateSchedules, updatePrivateSchedule } from '../../../../Features/Classes/Schedule/Teaching/Utils/TeachingUtils';
import Swal from 'sweetalert2';

/* **************************************************** */
/* CRUD Private Schedule                                */
/* **************************************************** */
export const fetchPrivateSchedule = (dispatch, filters, refetch) => {
    dispatch(fetchPrivateSchedules(filters));
}

export const handleUpdatePrivateSchedule = async (dispatch, item, setRefetch) => {
    try {
        Swal.fire({
            title: 'Update Private Schedule',
            html: `
                <label for="check_in_time">Check In Time</label>
                <input type="datetime-local" id="check_in_time" step="1" class="swal2-input" value="${item.check_in_time ? item.check_in_time.replace(' ', 'T') : ''}">
                
                <label for="check_out_time" style="display: block; margin-top: 20px;">Check Out Time</label>
                <input type="datetime-local" id="check_out_time" step="1" class="swal2-input" value="${item.check_out_time ? item.check_out_time.replace(' ', 'T') : ''}">
            `,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            showLoaderOnConfirm: true,
            preConfirm: () => {
                const check_in_time = document.getElementById('check_in_time').value;
                const check_out_time = document.getElementById('check_out_time').value;

                if (!check_in_time) {
                    Swal.showValidationMessage('Check In Time wajib diisi!');
                    return false;
                }

                if (check_out_time && check_out_time <= check_in_time) {
                    Swal.showValidationMessage('Check Out Time harus lebih besar dari Check In Time!');
                    return false;
                }

                // Ubah format dari "YYYY-MM-DDTHH:MM" menjadi "Y-m-d H:i:s"
                const formatDateTime = (datetime) => datetime ? datetime.replace("T", " ") : null;

                return {
                    check_in_time: formatDateTime(check_in_time),
                    check_out_time: formatDateTime(check_out_time)
                };
            }
        }).then(async (result) => {
            if (result.isConfirmed) {
                const updatedData = {
                    id: item.id,
                    check_in_time: result.value.check_in_time,
                    check_out_time: result.value.check_out_time
                };

                await dispatch(updatePrivateSchedule(updatedData));
                setRefetch(prevRefetch => !prevRefetch);

                Swal.fire(
                    'Berhasil!',
                    'Edit data berhasil disubmit.',
                    'success'
                );
            }
        });
    } catch (error) {
        console.error("Update error:", error);
    }
};

/* **************************************************** */
/* Pagination                                           */
/* **************************************************** */

export const handleBackPagination = (pagination, filters, dispatch, setFilters, setRefetch) => {
    if (pagination.current_page > 1) {
        dispatch(setFilters({
            ...filters,
            page: pagination.current_page - 1
        }));
        setRefetch(prevRefetch => !prevRefetch);
    }
}

export const handleNextPagination = (pagination, filters, dispatch, setFilters, setRefetch) => {
    if (pagination.current_page < pagination.last_page) {
        dispatch(setFilters({
            ...filters,
            page: pagination.current_page + 1
        }));
        setRefetch(prevRefetch => !prevRefetch);
    }
}

export const handleClickPagination = (page, filters, dispatch, setFilters, setRefetch) => {
    dispatch(setFilters({
        ...filters,
        page: page
    }));
    setRefetch(prevRefetch => !prevRefetch);
}